import React from 'react';
import { Table, Icon } from 'semantic-ui-react';
import { shortenMonth } from '../helpers/TableUtils.jsx';

const styles = {
  dateLabel: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '6px 12px',
    backgroundColor: '#f0f8f0',
    borderRadius: '6px',
    color: '#569556',
    fontWeight: '500',
    fontSize: '0.9rem',
  },
  cell: {
    verticalAlign: 'middle',
  },
};

const UpcommingGameItem = ({ bridgeEvent }) => {
  return (
    <Table.Row>
      <Table.Cell style={styles.cell}>
        <span style={styles.dateLabel}>
          <Icon name="calendar outline" style={{ margin: 0 }} />
          {bridgeEvent.event_day} {shortenMonth(bridgeEvent.event_month)} {bridgeEvent.event_year}
        </span>
      </Table.Cell>
      <Table.Cell style={styles.cell}>{bridgeEvent.event_club}</Table.Cell>
      <Table.Cell style={styles.cell}>{bridgeEvent.event_location}</Table.Cell>
      <Table.Cell style={styles.cell}>{bridgeEvent.event_year}</Table.Cell>
    </Table.Row>
  );
};

export default UpcommingGameItem;
